import axios from 'axios'
import {
  Message
} from 'element-ui'
import store from '@/store'
import router from '@/router'
import qs from 'qs'
import {
  pass_token
} from './util.js';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 50000000, // request timeout
})

// request interceptor
// 请求拦截器
service.interceptors.request.use(
  config => {
    if (config.url == '/v1/login') {

    } else {
      let token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
    }

    let dd = Object.assign(config.data, {
      apptype: "web",
      appversion: '1.0'
    });

    if (config.method == 'get') {
      config.url = config.url + '?' + qs.stringify({
        data: pass_token(dd)
      });
    } else {
      config.data = qs.stringify({
        data: pass_token(dd)
      });
    }

    if (location.hostname == 'www.hnlpa.cn') {
      config.url = 'https://api.hnlpa.cn' + config.url;
    } else {
      config.url = 'https://testapi.hnlpa.cn' + config.url;
      // config.url = 'http://hunanapi.com' + config.url; // huangr 本地
    }
      // config.url = 'https://api.hnlpa.cn' + config.url;
    // config.url = 'https://newhnyxapi.baitongshiji.com' + config.url;

    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  response => {

    if (response.data.code !== 200) {
      if (response.data.code == 401) {
        Message({
            message: '请先登录',
            type: 'error',
            duration: 5 * 1000
        })
        router.push('/');
        store.dispatch('logout');
      }else if( response.data.message ){
        Message({
            message: response.data.message,
            type: 'error',
            duration: 5 * 1000
        })
      }

      return Promise.reject(new Error(response.data.message || 'Error'))
    } else {
      return response
    }
  },
  error => {
    if (error.message == 'Network Error') {
      return false;
    }
    if (error.message == 'timeout of 50000000ms exceeded') {
      error.message = '网络连接超时，请刷新重试'
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request/request.js